import ReactPaginate from "react-paginate";

import Icon from "./Icon";

const PaginationComponent = ({ pageCount = 1, pageNumber, setPageNumber }) => {
  if (pageCount === 1) return null;

  return (
    <ReactPaginate
      previousLabel={<Icon icon="ep:d-arrow-right" />}
      nextLabel={<Icon icon="ep:d-arrow-left" />}
      pageClassName="page-item"
      pageLinkClassName="page-link bg-base border text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-48-px w-48-px"
      previousClassName="page-item"
      previousLinkClassName="page-link bg-base border text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-48-px w-48-px"
      nextClassName="page-item"
      nextLinkClassName="page-link bg-base border text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-48-px w-48-px"
      breakLabel="..."
      breakClassName="page-item"
      breakLinkClassName="page-link bg-base border text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-48-px w-48-px"
      pageCount={pageCount}
      marginPagesDisplayed={1}
      pageRangeDisplayed={2}
      onPageChange={(e) => setPageNumber(e.selected + 1)}
      containerClassName="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center mt-3"
      activeClassName="page-item"
      activeLinkClassName="page-link bg-base border text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-48-px w-48-px border-primary-400 text-primary-600"
      forcePage={pageNumber}
    />
  );
};
export default PaginationComponent;
